import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import { Accordion as BaseAccordion } from '@base-ui-components/react';
import { colors } from "../../tokens/color";
import React from 'react';
const styles = {
    padding: '0.8rem',
    border: `1px solid ${colors.border.primary}`,
    borderRadius: '8px',
    '&:focus-within': {
        borderColor: colors.border.activePrimary,
    },
};
/**
 * Contains all the parts of a collapsible section for the Accordion.
 */
export const AccordionItem = React.forwardRef(({ children, ...props }, ref) => (_jsx(BaseAccordion.Item, { css: styles, ref: ref, ...props, children: children })));
